
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import errorService from "../../services/errorService";
import uiService from "@/services/uiService";
import languages from "@/constant/language";
import {StoreServiceInstance} from "@/services/storeService";

export default Vue.extend({
  data() {
    return {
      errorService,
      error: "",
      showNoti: false,
      binding: {},
      hasBackRouter: "",
      title: "",
      errorLostNetwork: '',
      logo: '',
      languages,
      lang: {},
      overlay: false,
      updateStatus: {},
      back: () => {}
    };
  },
  watch: {
    $route: {
      handler() {
        this.hasBackRouter = this.$route.meta.hasBack;
        this.title = this.$t(this.$route.meta.title);
      },
      deep: true
    },
  },
  async created() {
    this.updateStatus = await msDataProvider.executeCommand("updateGetStatus");
    await this.getClientSetting();
    await msDataProvider.bindDataMany(
        ["uiConfig"],
        this.binding,
        this,
        null,
        this
    );
    this.lang = this.languages.find(x => x.key === StoreServiceInstance.getData('language'));
    msDataProvider.watchData(
        "authenAuthenInfoShouldBeNotified",
        () => {
          this.$router.push("/");
        },
        this,
        true
    );
    this.errorLostNetwork = this.$t('ERROR_SERVICE.ERROR_SERVICE_HOST_NAME');
  },
  methods: {
    backRouter() {
      if (this.$refs.routerView.back) {
        this.$refs.routerView.back();
        return;
      }
      if (this.hasBackRouter === 'logout') {
        this.logout();
        return;
      } else if (typeof this.hasBackRouter === 'function') {
        if (this.$route.query.isShowQrCode === false) {
          this.hasBackRouter(this.$router, {query: { isShowQrCode: true }});
        } else {
          this.logout();
          return;
        }
      } else if (typeof this.hasBackRouter === 'string') {
        this.$router.push(this.hasBackRouter)
      } else {
        this.$router.back();
      }
    },
    errorHandler(err) {
      if (err === "") {
        this.error = "";
        this.showNoti = false;
        return;
      }
      this.error = err;
      this.showNoti = true;
    },
   async logout() {
      const confirmed = await uiService.executeCommand(
        "confirmShow",
        {
          message: this.$t("LAYOUT.DO_YOU_REALLY_WANT_TO_LOGOUT_THIS_APP"),
          title: this.$t("LAYOUT.LOGOUT"),
          cancel: this.$t("LAYOUT.CANCEL"),
          ok: this.$t("LAYOUT.LOGOUT"),
          iconOk: 'icon-logout-white24'
        },
        true
      );
      if (!confirmed) return;

      uiService.executeCommand("try", {
        async func() {
          await msDataProvider.executeCommand("authenLogout", {});
          sessionStorage.removeItem('userId');
          await new Promise(resolve => setTimeout(resolve, 0));
          const currentPath = this.$route.path;
          if (currentPath === '/login/prepare') {
            await this.$router.push("/login/username_password").catch(() => {});
          } else {
            await this.$router.push("/prepare").catch(() => {});
          }
        },
        self: this,
      });
    },

    openHelpCenter() {
      uiService.executeCommand('helpCenterShow', true);
    },
    async updateSetting(language: string) {
      await StoreServiceInstance.setData('language', language);
      window.location.reload();
    },
    async goToHelpCenter() {
      const baseUrl = "https://localhost:40001/ui";
      const url = "/user-guide/index";
      const authenToken = sessionStorage.getItem("authenToken") || "";
      let authorizedToken = "";
      if (authenToken) {
        authorizedToken = `authorized_token=${authenToken}`;
      }
      try {
        await msDataProvider.executeCommand("extOpenUrl", {
          url: baseUrl + url + "?" + authorizedToken,
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getClientSetting() {
      const res: any = await msDataProvider.getData("clientSetting");
      if (
          res &&
          res.settings &&
          res.settings.logo &&
          res.settings.logo.main_logo
      ) {
        this.logo = res.settings.logo.main_logo;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
